import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';

interface ISdRefField {
	settingsId: string;
	onChange: (value: string) => void;
}

const SdRefField: React.FC<ISdRefField> = ({ onChange, settingsId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterSdRef') }], [t]);

	return (
		<FormInput
			testId="SdRefField"
			name={`sdRef-${settingsId}`}
			label="sdRefLabel"
			onChange={onChange}
			maxLength={255}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(SdRefField);
